import {
  Directive,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { PrimitiveTypes } from '@angular/cli/src/analytics/analytics-parameters';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export class BaseRadioDirective implements ControlValueAccessor {
  label: InputSignal<string> = input<string>('');
  name: InputSignal<string> = input.required<string>();
  radioValue: InputSignal<PrimitiveTypes> = input.required<PrimitiveTypes>();

  value: WritableSignal<PrimitiveTypes> = signal<PrimitiveTypes>('');
  isArray: InputSignal<boolean> = input<boolean>(false);

  onValueChange() {
    this.value.set(this.radioValue());
    this.onChange(this.isArray() ? [this.radioValue()] : this.radioValue());
  }

  // ControlValueAccessor
  onChange = (value: PrimitiveTypes | PrimitiveTypes[]) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(outsideValue: PrimitiveTypes | PrimitiveTypes[]): void {
    const value: PrimitiveTypes = Array.isArray(outsideValue)
      ? outsideValue[0]
      : outsideValue;

    this.value.set(value);
  }
}
